export default "__VITE_ASSET__5b40249d__"